import inView from "in-view";
export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
			delayed: false,
			delayTimer: 1000,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "textanimations";
		this.delayTimer = this.defaults.delayTimer;
		if (this.options.$el) {
			this.$el = this.options.$el;

			if (this.$el.classList.contains("theme-page-title")) {
				this.delayTimer = 2000;
			}

			if (this.options.delayed) {
				setTimeout(() => {
					this.init(true);
				}, this.delayTimer);
			} else {
				this.init(true);
			}
		}
	}

	init(bool) {
		if (bool) {
			// generate a random ID for the element
			const randomID =
				"EYEBEAM_" + Math.random().toString(36).substr(2, 9);
			if (this.$el.children.length > 0) {
				this.$el = this.$el.children[0];
			}
			this.$el.setAttribute("id", randomID);
			const trimmedTitle = this.$el.textContent.trim();
			this.$el.setAttribute("aria-label", trimmedTitle);
			this.$el.innerHTML = this.$el.textContent.replace(
				/\S/g,
				"<span class='letter'>$&</span>"
			);
			if (!this.$el.classList) {
				this.$el.className = "aniEl";
			} else {
				this.$el.classList.add("aniEl");
			}
			// this.$el.querySelectorAll(".letter").forEach((el, i) => {
			// 	el.style.setProperty("--index", i);
			// 	// el.classList.add("letter-" + el.innerHTML.toUpperCase());
			// });

			// inView.offset(80);
			inView.threshold(1);
			inView(`#${randomID}`)
				.on("enter", (el) => {
					// el.querySelectorAll(".letter").forEach((el, i) => {
					// 	setTimeout(() => {
					// 		el.classList.add("aniEl_In");
					// 	}, 100 * i);
					// });
					el.setAttribute("data-ani", "true");
				})
				.on("exit", (el) => {
					// el.classList.remove("aniEl_In");
					el.setAttribute("data-ani", "false");
					const totalLetters = el.querySelectorAll(".letter").length;
					el.querySelectorAll(".letter").forEach((el, i) => {
						setTimeout(() => {
							el.classList.remove("aniEl_In");
						}, 100 * (totalLetters - i));
					});
				});
		}
	}
}
